import { render, staticRenderFns } from "./payrollRequest.vue?vue&type=template&id=191d106c&scoped=true"
import script from "./payrollRequest.vue?vue&type=script&lang=js"
export * from "./payrollRequest.vue?vue&type=script&lang=js"
import style0 from "./payrollRequest.vue?vue&type=style&index=0&id=191d106c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d106c",
  null
  
)

export default component.exports